import { ArrowUpRight } from "lucide-react";

export default function Contact({ onBook }) {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-20 md:py-28 bg-black text-white"
    >
      <div className="max-w-3xl mx-auto px-6 sm:px-8 text-center">
        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
          Let&rsquo;s solve your next <br />
          <span className="italic">growth challenge.</span>
        </h2>
        <p className="mt-6 text-lg text-white/70 leading-relaxed">
          Tell us where growth is getting difficult. We&rsquo;ll explore what
          needs to change.
        </p>
        <button
          data-testid="contact-book-btn"
          onClick={onBook}
          className="group mt-9 inline-flex items-center gap-3 h-12 px-7 bg-white text-black text-[15px] font-medium hover:bg-zinc-200 transition-colors duration-300"
        >
          Discuss Your Growth Challenge
          <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </button>
      </div>
    </section>
  );
}
